// extracted by mini-css-extract-plugin
export default {"marketplaceLayout":"_iqrf8f"};